import { useState } from "react"
import { useConnectionStateListener } from "ably/react"

/**
 * Status de conexão do WebSocket
 */
export type WebSocketConnectionStatus = "connecting" | "connected" | "disconnected"

/**
 * Hook para monitorar o status de conexão do WebSocket
 */
export function useWebSocketStatus() {
  const [status, setStatus] = useState<WebSocketConnectionStatus>("disconnected")

  useConnectionStateListener(event => {
    if (["connected", "connecting", "disconnected"].includes(event.current)) {
      setStatus(event.current as WebSocketConnectionStatus)
    }
  })

  return {
    status,
  }
}
